export default "__VITE_ASSET__dc95b76d__"